var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"add-company",on:{"click":_vm.button_client}},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"direita hover-change-color-pointer pad-5"},[_c('img',{staticClass:"esquerda icon-user",attrs:{"src":"/imgs/icons/person-plus-white.svg"}}),_vm._v(" "),_c('p',{staticClass:"esquerda"},[_vm._v("Usar cliente")])])
}]

export { render, staticRenderFns }